import AxiosInstance from 'config/apiServiceApiGateway'

import { rolesIdQuery, rolesQuery } from '../constants/picParams'

export type VendorDataSKPResponseType = {
  data: {
    astro_pic_catman_name: string
    astro_pic_catman_role: string
    astro_pic_finance_collection_name: string
    pic_email: string
    pic_name: string
    pic_role: string
    pic_phone_number: string
    billing_name: string
    billing_address: string
  }
}

export type GetIdUserResponseType = {
  data: {
    users: {
      created_at: string
      updated_at: string
      email: string
      full_name: string
      verified: boolean
      position: string
      password: string
      active: boolean
      phone_number: string
      id: number
    }[]
  }
  error: {
    message: string
    status: boolean
    code: number
  }
  pagination: {
    page_index: number
    direction: string
    page_size: number
    sort: string
    number_of_elements: number
    total_elements: number
    total_pages: number
  }
}

export type PutVendorDataSKPPayloadType = {
  astro_pic_catman_id: number
  astro_pic_catman_role: string
  astro_pic_finance_collection_id: number
  pic_email: string
  pic_name: string
  pic_role: string
  pic_phone_number: string
  billing_name: string
  billing_address: string
}

export type PutVendorDataSKPResponseType = {
  message: string
  error: {
    message: string
    code: number
    status: boolean
  }
}

export const getVendorDataSKP = (vendor_id: number) =>
  AxiosInstance.Get<VendorDataSKPResponseType, true>({
    url: `/commercial/internal/:version/vendor/${vendor_id}/skp-info`,
    version: 'v1',
  })

export const getIdUser = (params: string) =>
  AxiosInstance.Get<GetIdUserResponseType, true>({
    url: `/accounts/internal/:version/user/location/role?${rolesQuery}&${rolesIdQuery}&${params}`,
    version: 'v1',
  })

export const putVendorDataSKP = (vendor_id: number, data: PutVendorDataSKPPayloadType) =>
  AxiosInstance.Put<PutVendorDataSKPResponseType, true>({
    url: `/commercial/internal/:version/vendor/${vendor_id}/skp-info`,
    version: 'v1',
    data,
  })
